// import fetchWrapper from "./useFetch";
import { isAccountFeePaid } from "./accountFee";

const calculateBusiness = async (data) => {
  let num = 0;

  if (
    data?.firstName?.length > 0 &&
    data?.firstName !== "None" &&
    data?.firstName !== null &&
    data?.firstName !== "null"
  ) {
    num += 1;
  }

  if (
    data?.lastName?.length > 0 &&
    data?.lastName !== "None" &&
    data?.lastName !== null &&
    data?.lastName !== "null"
  ) {
    num += 1;
  }

  if (
    data?.phone?.length > 0 &&
    data?.phone !== "None" &&
    data?.phone !== null &&
    data?.phone !== "null"
  ) {
    num += 1;
  }

  if (
    data?.email?.length > 0 &&
    data?.email !== "None" &&
    data?.email !== null &&
    data?.email !== "null"
  ) {
    num += 1;
  }

  if (
    data?.storeName?.length > 0 &&
    data?.storeName !== "None" &&
    data?.storeName !== undefined &&
    data?.city !== null &&
    data?.city !== "null"
  ) {
    num += 1;
  }

  if (
    data?.description?.length > 0 &&
    data?.description !== "None" &&
    data?.description !== undefined &&
    data?.description !== null &&
    data?.description !== "null"
  ) {
    num += 1;
  }

  if (
    data?.address1?.length > 0 &&
    data?.address1 !== "None" &&
    data?.address1 !== undefined &&
    data?.address1 !== null &&
    data?.address1 !== "null"
  ) {
    num += 1;
  }

  if (
    data?.state?.length > 0 &&
    data?.state !== "None" &&
    data?.state !== undefined &&
    data?.state !== null &&
    data?.state !== "null"
  ) {
    num += 1;
  }

  if (
    data?.city?.length > 0 &&
    data?.city !== "None" &&
    data?.city !== undefined &&
    data?.city !== null &&
    data?.city !== "null"
  ) {
    num += 1;
  }

  if (
    data?.zip?.length > 0 &&
    data?.zip !== "None" &&
    data?.zip !== undefined &&
    data?.zip !== "null" &&
    data?.zip !== null
  ) {
    num += 1;
  }

  const percent = (num / 10) * 100;
  return percent;
};

const calculateOnline = async (data) => {
  let num = 0;

  if (
    data?.website !== undefined &&
    data?.website !== null &&
    data?.website !== "None" &&
    data?.website?.length > 0
  ) {
    num += 1;
  }

  if (
    data?.facebook !== undefined &&
    data?.facebook !== null &&
    data?.facebook !== "None" &&
    data?.facebook?.length > 0
  ) {
    num += 1;
  }

  if (
    data?.instagram !== undefined &&
    data?.instagram !== null &&
    data?.instagram !== "None" &&
    data?.instagram?.length > 0
  ) {
    num += 1;
  }

  if (
    data?.etsy !== undefined &&
    data?.etsy !== null &&
    data?.etsy !== "None" &&
    data?.etsy?.length > 0
  ) {
    num += 1;
  }

  if (data?.storeProductPictures > 0) {
    num += 1;
  }

  if (data?.otherWebsiteLinks > 0) {
    num += 1;
  }

  const percent = (num / 1) * 100;
  if (percent >= 100) {
    return 100;
  } else {
    return percent;
  }
};

const calculateCategories = async (data) => {
  if (
    data?.categories !== undefined &&
    data?.categories !== "None" &&
    data?.categories?.length > 0
  ) {
    return 100;
  } else {
    return 0;
  }
};

const calculatePayment = async (data) => {
  if (
    data?.payment !== undefined &&
    data?.payment !== "None" &&
    data?.payment === true
  ) {
    return 100;
  } else {
    return 0;
  }
};

export const calculateDashboard = async (data) => {
  if (
    data?.account_status === "incomplete" ||
    data?.account_status === "need more info"
  ) {
    const dataBusiness = {
      firstName: data?.first_name,
      lastName: data?.last_name,
      phone: data?.account_phone,
      email: data?.email,
      storeName: data?.store_name,
      description: data?.store_description,
      address1: data?.store_street1,
      address2: data?.store_street2,
      state: data?.store_state,
      city: data?.store_city,
      zip: data?.store_zip,
    };

    const businessPercent = await calculateBusiness(dataBusiness);

    const dataOnline = {
      website: data?.store_website,
      facebook: data?.facebook,
      instagram: data?.instagram,
      etsy: data?.etsy,
      storeProductPictures: data?.store_product_pictures,
      otherWebsiteLinks: data?.other_website_links,
    };

    const onlinePercent = await calculateOnline(dataOnline);

    const dataCategories = {
      categories: data?.store_categories,
    };

    const categoriesPercent = await calculateCategories(dataCategories);

    const paymentPercent = await calculatePayment({
      payment: isAccountFeePaid(data),
    });

    //   await fetch(
    //     `${process.env.NEXT_PUBLIC_BASE_CMS}/api/user/dashboard/update/account_status`,
    //     {
    //       method: "PATCH",
    //       credentials: "include",
    //       data: { account_status: "pending" },
    //     },
    //   );
    // }

    const totalPercent =
      ((businessPercent + onlinePercent + categoriesPercent + paymentPercent) /
        400) *     100;

    return {
      business: businessPercent,
      online: onlinePercent,
      categories: categoriesPercent,
      payment: paymentPercent,
      total: totalPercent,
    };
  } else if (data?.account_status === "pending") {
    const paymentPercent = await calculatePayment({
      payment: isAccountFeePaid(data),
    });

    const totalPercent = ((300 + paymentPercent) / 400) * 100;

    return {
      business: 100,
      online: 100,
      categories: 100,
      payment: paymentPercent,
      total: totalPercent,
    };
  } else if (data?.account_status === "approved") {
    return null;
  } else if (data?.account_status === "application fee") {
    const paymentPercent = await calculatePayment({
      payment: isAccountFeePaid(data),
    });

    return {
      business: 100,
      online: 100,
      categories: 100,
      payment: paymentPercent,
      total: ((300 + paymentPercent) / 400) * 100,
    };
  }
};